<div class="bv-sends-filters" data-testid="filters">
  <div class="bv-sends-filters__header" data-testid="filters-header">
    {{ "filters" | i18n }}
    <span class="bv-sends-filters__info" aria-hidden="true"></span>
  </div>
  <div class="bv-sends-filters__body" data-testid="filters-body">
    <ul class="bv-sends-filters__list">
      <li>
        <button
          type="button"
          class="bv-sends-filters__option"
          [class.bv-sends-filters__option--active]="selected() === sendFilterType.All"
          (click)="onSelect(sendFilterType.All)"
        >
          <i class="bwi bwi-send" aria-hidden="true"></i>
          <span>{{ "allSends" | i18n }}</span>
        </button>
      </li>
    </ul>
    <h3 class="bv-sends-filters__section">{{ "types" | i18n }}</h3>
    <ul class="bv-sends-filters__list">
      <li>
        <button
          type="button"
          class="bv-sends-filters__option"
          [class.bv-sends-filters__option--active]="selected() === sendFilterType.Text"
          (click)="onSelect(sendFilterType.Text)"
        >
          <i class="bwi bwi-star" aria-hidden="true"></i>
          <span>{{ "sendTypeText" | i18n }}</span>
        </button>
      </li>
      <li>
        <button
          type="button"
          class="bv-sends-filters__option"
          [class.bv-sends-filters__option--active]="selected() === sendFilterType.File"
          (click)="onSelect(sendFilterType.File)"
        >
          <i class="bwi bwi-file" aria-hidden="true"></i>
          <span>{{ "sendTypeFile" | i18n }}</span>
        </button>
      </li>
    </ul>
  </div>
</div>
